import React from "react";
import { _CustomerDashboard } from "../../components/dashboard/customer";
const CustomerDashboard = () => {
  return (
    <div>
      <h2>Cliente Dashboard</h2>
      <_CustomerDashboard />
    </div>
  );
};

export default CustomerDashboard;
